import React from 'react';
import s from './ThreeSteps.module.css';
import { useNavigate } from 'react-router-dom';
import {
    OptimizedMotionH2,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const ThreeSteps: React.FC = () => {
    const navigate = useNavigate();
    const steps = [
        {
            id: 1,
            text: 'No special equipment needed, just your image or prompt',
        },
        {
            id: 2,
            text: 'Let our brand engine detect it, select your colors and voice',
        },
        {
            id: 3,
            text: 'Download or share directly your visuals and prepare to impress',
        },
    ];

    return (
        <section className={s.container}>
            <OptimizedMotionH2 type="slide-up" delay={0.3} className={s.title}>
                <span className={s.highlight}>3 simple steps</span> to stunning visuals
            </OptimizedMotionH2>
            <OptimizedMotionP type="slide-up" delay={0.8} className={s.subtitle}>
                Your path to a cohesive and attractive brand
            </OptimizedMotionP>

            <div className={s.stepsGrid}>
                {steps.map((step) => (
                    <div key={step.id} className={s.stepCard}>
                        <div className={s.stepNumber}>{step.id}</div>
                        <OptimizedMotionP type="slide-up" delay={1.0} className={s.stepText}>
                            {step.text}
                        </OptimizedMotionP>
                    </div>
                ))}
            </div>

            <button className={s.ctaButton} onClick={() => navigate('/contact')}>
                Request Access
            </button>
        </section>
    );
};

export default ThreeSteps;
